import ApiResponseBase from '../../../../../Base/Domain/ApiResponseBase';
import AccountSummaryModel from '../AccountSummaryModel';

class AdminAccountSummaryResponseModel extends ApiResponseBase {

  constructor(params) {

    super(params);

    if (typeof params === 'undefined' || params === null) {
      return;
    }

    this.AccountSummary = new AccountSummaryModel(params.accountSummary);

  }

}

export default AdminAccountSummaryResponseModel;